import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  PiBriefcaseFill,
  PiBuildingsFill,
  PiCoinsFill,
  PiCpuFill,
  PiGlobeHemisphereWestFill,
  PiUsersThreeFill,
} from 'react-icons/pi';
import { TbBrandYoutubeFilled } from 'react-icons/tb';
import { HiMiniNewspaper, HiMiniWallet } from 'react-icons/hi2';
import {
  LuBellRing,
  LuBriefcaseBusiness,
  LuCloudDownload,
  LuFileText,
  LuHeartHandshake,
  LuMapPinned,
  LuMenu,
  LuPhone,
  LuSearchCheck,
  LuSettings2,
  LuShoppingCart,
  LuX,
} from 'react-icons/lu';

const menuRows = [
  [
    { to: '/about', icon: PiBuildingsFill, label: 'About Us' },
    { href: 'https://shop.shreejisecuresofttech.com/', icon: LuShoppingCart, label: 'Shop' },
    { to: '/watch', icon: TbBrandYoutubeFilled, label: 'Watch' },
    { to: '/finance', icon: HiMiniWallet, label: 'Finance' },
    { to: '/contact', icon: LuPhone, label: 'Contact Us' },
  ],
  [
    { to: '/business-consultancy', icon: PiBriefcaseFill, label: 'Consultancy' },
    { to: '/jobs', icon: LuBriefcaseBusiness, label: 'Jobs' },
    { to: '/hr-services', icon: PiUsersThreeFill, label: 'HR Services' },
    { to: '/itr-filling', icon: LuFileText, label: 'ITR Filling' },
    { to: '/gst-filling', icon: PiCoinsFill, label: 'GST Filling' },
  ],
  [
    { to: '/tours-and-travel', icon: LuMapPinned, label: 'Tours & Travel' },
    { to: '/doorbell', icon: LuBellRing, label: 'Doorbell' },
    { to: '/other-services', icon: LuSettings2, label: 'Other Services' },
    { to: '/coming-soon', icon: HiMiniNewspaper, label: 'News' },
    { to: '/detective-services', icon: LuSearchCheck, label: 'Detective' },
  ],
  [
    { to: '/charity', icon: LuHeartHandshake, label: 'Charity' },
    { to: '/device-care', icon: PiCpuFill, label: 'Device Care' },
    { to: '/coming-soon', icon: PiGlobeHemisphereWestFill, label: 'Social Media' },
    { to: '/coming-soon', icon: LuCloudDownload, label: 'Softwares & OS' },
  ],
];

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const renderShortcut = ({ to, href, icon: Icon, label }) => {
    const content = (
      <div className="shortcut-card">
        <span className="shortcut-image">
          <Icon size={32} />
        </span>
        <span className="truncate">{label}</span>
      </div>
    );

    if (href) {
      return (
        <a
          key={label}
          href={href}
          className="shortcut-link"
          onClick={() => setIsMenuOpen(false)}
        >
          {content}
        </a>
      );
    }

    return (
      <Link
        key={label}
        to={to}
        className="shortcut-link"
        onClick={() => setIsMenuOpen(false)}
      >
        {content}
      </Link>
    );
  };

  return (
    <header className="relative z-[100] mx-auto flex w-[94%] items-center justify-center gap-4 sm:w-4/5">
      <Link to="/" aria-label="Go to home" className="inline-flex">
        <img className="logo-image" src="./logo.png" alt="Shree Ji Secure Soft Tech logo" />
      </Link>

      <div className="absolute right-0 top-0 z-[120]">
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-[8px] border border-cyan-300/30 bg-cyan-300/10 px-4 py-2.5 text-sm font-semibold text-cyan-100 transition hover:border-cyan-200 hover:bg-cyan-300/15"
          onClick={() => setIsMenuOpen((current) => !current)}
          aria-expanded={isMenuOpen}
          aria-controls="site-header-menu"
        >
          {isMenuOpen ? <LuX size={20} /> : <LuMenu size={20} />}
          Menu
        </button>

        {isMenuOpen && (
          <div
            id="site-header-menu"
            className="absolute right-0 z-[130] mt-3 max-h-[75vh] w-[min(94vw,620px)] overflow-y-auto rounded-[22px] border border-white/10 bg-[#05090d] px-3 py-4 shadow-[0_24px_70px_rgba(0,0,0,0.72)]"
          >
            <nav aria-label="Site menu">
              <div className="top-row">
                <div className="shortcut-grid">
                  {menuRows[0].map(renderShortcut)}
                </div>
              </div>
              <div className="bottom-row">
                <div className="shortcut-grid">
                  {menuRows[1].map(renderShortcut)}
                </div>
              </div>
              <div className="third-row">
                <div className="shortcut-grid">
                  {menuRows[2].map(renderShortcut)}
                </div>
              </div>
              <div className="fourth-row">
                <div className="shortcut-grid shortcut-grid-compact">
                  {menuRows[3].map(renderShortcut)}
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
